import * as React from 'react'
import {batch} from "@preact/signals-react";
import {Box} from "@mui/material";
import {SwitchSeeker} from "@ui-seeker/core";
import {postSubmit} from "@ui-seeker/utils";


import {NotAllowedBlock} from "@components";
import {WEBBACK_V2_API} from "@constants";
import {useToast} from "@hooks";


export default function enabledColumn() {
    return [{
        name: 'enabled',
        label: 'Enabled',
        options: {
            display: 'excluded',
            customBodyRowRender: v => v ? 'Yes' : 'No'
        }
    },{
        name: 'enabled', label: 'Enabled',
        options: {
            filter: false,
            customBodyRowRender: (value, row, _, updateValue) =>
                <EnabledColumnSwitch
                    value={value}
                    row={row}
                    updateValue={updateValue}
                />
        }
    }]
}

const EnabledColumnSwitch = ({ value, row, updateValue }) => {
    const { showToast } = useToast()

    const handleChange = () => {
        const updatedRow = { ...row, ['enabled']: !value }
        batch(() => {
            showToast.promise(
                postSubmit(`${WEBBACK_V2_API}/monitoring/admin/enabled`, updatedRow)
                    .then(() => {
                        updateValue(!value)
                    })
                    .catch(() => {
                        showToast.error()
                    }),
                {
                    success: `${updatedRow['name']} updated!`,
                    loading: 'Updating...',
                }
            )
        })
    }

    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {value === null ? (
                <NotAllowedBlock />
            ) : (
                <SwitchSeeker
                    formControlProps={{ sx: { margin: '0 auto' } }}
                    checked={!!value}
                    onChange={handleChange}
                />
            )}
    </Box>
}